import React from 'react';

/*
  This "editor" component is based on the CustomVariables component.
  It is changed to handle two input objects in props (prices and advanves),
  and will create a combined editor for both, as they should share keys.
  This is done because the lease have two different fields in contentful, and we do
  not want to bother with breaking existing data in the json fields.
*/
class LeasePriceOverrideEditor extends React.Component {
  constructor(props) {
    super(props);
    this.handleVariables = this.handleVariables.bind(this);
    this.addVariable = this.addVariable.bind(this);
    this.deleteVariable = this.deleteVariable.bind(this);
    this.handleSaveVariables = this.handleSaveVariables.bind(this);
    this.parseVariablesFromProps = this.parseVariablesFromProps.bind(this);
    this.handleTagAdd = this.handleTagAdd.bind(this);

    const variables = this.parseVariablesFromProps(props);

    this.state = {
      variables: variables,
      updated: false,
      error: false
    };

    this.changeDebouncer = null;
  }

  UNSAFE_componentWillReceiveProps(next) { // eslint-disable-line camelcase
    const variables = this.parseVariablesFromProps(next);
    this.setState({
      variables: variables,
      updated: false
    });
  }

  parseVariablesFromProps(props) {
    return [...new Set(Object.keys(props.prices || {}).concat(Object.keys(props.advances || {})))].map((groupTag) => ({
      key: groupTag,
      value: [props.prices?.[groupTag] ?? '', props.advances?.[groupTag] ?? '']
    }));
  }

  // Only keep numeric values (strip formating)
  parseValue(v) {
    const value = parseInt((`${v}`).replace(/\D+/g, ''), 10);
    if (isNaN(value)) {
      return '';
    }
    return value;
  }

  // Replace whitespace with dash
  parseKey(k) {
    return k.replace(/\s/g, '-');
  }

  handleSaveVariables() {
    const stateVars = this.state.variables;
    let error = false;
    const newPrices = {};
    const newAdvances = {};

    for (let i = 0; i < stateVars.length; i++) {
      const pair = stateVars[i];

      if (pair.key === '') {
        pair.key = i.toString();
      }
      const key = pair.key.trim();

      if (newPrices.hasOwnProperty(key)) {
        error = true;
        break;
      }

      // Make sure all are formated correct (even unchanged ones who have not gone throug the latest handleVariables)
      newPrices[key] = this.parseValue(pair.value[0]);
      newAdvances[key] = this.parseValue(pair.value[1]);
    }

    if (error) {
      this.setState({
        error: true
      });
    } else {
      this.props.onSave({
        prices: newPrices,
        advances: newAdvances
      });
    }
  }

  handleVariables(e) {
    const index = e.target.dataset.index;
    const field = e.target.name;
    let value = e.target.value;
    const stateVars = this.state.variables;

    if (field === 'key') {
      value = this.parseKey(value);
      stateVars[index][field] = value;
    } else {
      value = this.parseValue(value);
      if (field === 'price') {
        value = [value, stateVars[index].value[1]];
      } else {
        value = [stateVars[index].value[0], value];
      }

      stateVars[index].value = value;
    }

    this.setState({
      variables: stateVars,
      updated: true,
      error: false
    });

    clearTimeout(this.changeDebouncer);
    this.changeDebouncer = setTimeout(() => {
      this.handleSaveVariables();
    }, 350);
  }

  handleTagAdd(e, tag) {
    e.preventDefault();

    const stateVars = this.state.variables;
    stateVars.push({
      key: tag,
      value: ['', '']
    });
    this.setState({
      variables: stateVars,
      updated: true,
      error: false
    });

    clearTimeout(this.changeDebouncer);
    this.changeDebouncer = setTimeout(() => {
      this.handleSaveVariables();
    }, 350);
  }

  addVariable() {
    const stateVars = this.state.variables;
    stateVars.push({
      key: '',
      value: ['', '']
    });
    this.setState({
      variables: stateVars,
      updated: true,
      error: false
    });
  }

  deleteVariable(index) {
    index = parseInt(index, 10);
    const newVars = Array.from(this.state.variables);
    newVars.splice(index, 1);

    this.setState({
      variables: newVars,
      updated: true,
      error: false
    });

    clearTimeout(this.changeDebouncer);
    this.changeDebouncer = setTimeout(() => {
      this.handleSaveVariables();
    }, 350);
  }

  render() {
    return (
      <div className="form-group">
        <div className="row mf-margin-bottom-5">
          <div className="col-xs-4"><label>Tag</label></div>
          <div className="col-xs-3"><label>Månedspris</label></div>
          <div className="col-xs-3"><label>Startleie</label></div>
        </div>
        {this.state.variables.map((pair, index) => {
          return (
            <div className="row" key={`${this.state.variables.length}-${index}`}>
              <div className="col-xs-4">
                <div className="mf-margin-bottom-5">
                  <input
                    type="text"
                    className="form-control"
                    data-index={index}
                    name='key'
                    disabled={this.props.disabled}
                    value={pair.key}
                    onChange={(e) => this.handleVariables(e)}
                  />
                </div>
              </div>
              <div className="col-xs-3">
                <div className="mf-margin-bottom-5">
                  <input
                    type="text"
                    className="form-control text-right"
                    data-index={index}
                    disabled={this.props.disabled}
                    name='price'
                    value={pair.value[0]}
                    onChange={(e) => this.handleVariables(e)}
                  />
                </div>
              </div>
              <div className="col-xs-3">
                <div className="mf-margin-bottom-5">
                  <input
                    type="text"
                    className="form-control text-right"
                    data-index={index}
                    disabled={this.props.disabled}
                    name='advance'
                    value={pair.value[1]}
                    onChange={(e) => this.handleVariables(e)}
                  />
                </div>
              </div>
              <div className="col-xs-2">
                <button
                  type="button"
                  className="btn btn-danger"
                  disabled={this.props.disabled}
                  title="Slett dette feltet"
                  onClick={(e) => this.deleteVariable(index, e)}
                >
                  <i className="fa fa-remove"></i>
                </button>
              </div>
            </div>
          );
        })}
        <button
          className="btn btn-default"
          type="button"
          disabled={this.props.disabled}
          onClick={() => this.addVariable()}
        >
          <i className="fa fa-plus" aria-hidden="true"></i> Nytt felt
        </button>
        &nbsp;
        {this.state.error &&
          <span className="text-danger"><i className="fa fa-exclamation-triangle"></i> Feil: To eller fler av feltene er like</span>
        }
        {this.props.tags && <div>
          <br />
          {this.props.tags.map((tag) => <React.Fragment key={tag} ><a href="#" onClick={(e) => this.handleTagAdd(e, tag)} className="label label-primary">{tag}</a> </React.Fragment>)}
        </div>}
      </div>
    );
  }
}

LeasePriceOverrideEditor.defaultProps = {
  prices: {},
  advances: {},
  onSave: () => {}
};

export default LeasePriceOverrideEditor;
